export default {
  //课中活动问卷
  quesList:[],
  ansList:[],
  quesInfo:{
    add:'',
    addTest:'',
    edit:'',
    del:"",
    detail:''
  }
}
